import script from "./FooterLink.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterLink.vue?vue&type=script&setup=true&lang=js"

import "./FooterLink.vue?vue&type=style&index=0&id=68588bde&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68588bde"]])

export default __exports__